module.exports = __webpack_public_path__ + "img/高性能.a36f1a2f.png";